export type ExtensionRemoteLoader = <T = unknown>(
  remoteEntry: string,
  remoteName: string,
  exposedModule: string,
) => Promise<T>;

let remoteLoader: ExtensionRemoteLoader | undefined;

export function setExtensionRemoteLoader(loader: ExtensionRemoteLoader | undefined): void {
  remoteLoader = loader;
}

export function getExtensionRemoteLoader(): ExtensionRemoteLoader | undefined {
  return remoteLoader;
}
